import { useTextes } from '@common/config';
import { ContactButton, ContactModal, getModalById } from '@common/ui';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useInscriptionState } from '../../hooks/use-inscription-state.hook';

const contactModal = getModalById('contact-modal');

export const StepperLayout = () => {
  const { organisme } = useInscriptionState();
  const t = useTextes('Inscription', 'Etape1Administrateurs');
  const t_repr = useTextes('Inscription', 'Etape2Représentant');

  return (
    <div className={'flex flex-col gap-4 items-center p-4 pb-8 bg-[#f0f0f0]'}>
      <div className={'flex flex-col w-full max-w-[900px]'}>
        <div className={'flex items-center'}>

          <h3
            className={'flex-1 !mb-1'}>{(organisme?.majAnnuelle) ? t['INSCR_ADM_TEXT1_MAJ_ANNUELLE'] : t['INSCR_ADM_TEXT1_CREATION']}</h3>

          <div>
            <ContactButton onClick={() => contactModal.open()} />
          </div>
        </div>

        <span
          className={'text-[#000091] text-lg'}>SIREN n° {organisme?.siren} - {(organisme?.diffusible) ? organisme.raisonSociale : '(Non diffusible)'}</span>

        <span className={'mt-4'}>{t['INSCR_ADM_TEXT2']}</span>
      </div>

      <div className={'w-full max-w-[900px] py-[56px] px-[102px] bg-white'}>
        <Outlet />
      </div>

      <div className={'flex flex-col w-full max-w-[900px] px-4'}>
        <div className={'flex flex-row items-center gap-4'}>
          <span className={'text-sm'} style={{ color: 'red' }}>{t_repr['INSCR_REPR_TEXT5_RED']}</span>
          <span>{t_repr['INSCR_REPR_TEXT5']}</span>
        </div>
      </div>

      <ContactModal dsfrModal={contactModal} />
    </div>
  );
};
